import Vue from 'vue'
//Vue.config.devtools = true;
import App from './App.vue'
import router from './router/router'
import store from './store/store'
import VueLogger from 'vuejs-logger';
// import './registerServiceWorker'
import axios from 'axios'
import API from './API'
import head from 'vue-head'
import CloudinaryCore from 'cloudinary-core';
/*import VueGtm from 'vue-gtm'
import VueAnalytics from 'vue-analytics'*/
import {
    VueHammer
} from 'vue2-hammer'

if (process.env.NODE_ENV == 'production')
    console.log = () => {}



var cloudinary = new CloudinaryCore.Cloudinary({
    cloud_name: process.env.VUE_APP_CLOUDINARY_CLOUD_NAME
});

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$api = new API(axios)
/*
Vue.use(VueGtm, {
    id: process.env.VUE_APP_GTM,
    enabled: true,
    vueRouter: router,
    ignoredViews: []
});

Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_UA,
    router
})*/

const isProduction = process.env.NODE_ENV === 'production';
const options = {
    isEnabled: true,
    logLevel :  'debug',
    stringifyArguments : false,
    showLogLevel : true,
    showMethodName : true,
    separator: '|',
    showConsoleColors: true
};
Vue.use(VueLogger, options);

Vue.use(VueHammer)


new Vue({
    router,
    store,
    head,
    provide() {
        return {
            $cloudinary: cloudinary
        }
    },
    render: h => h(App)
}).$mount('#app')
